import { render, staticRenderFns } from "./oxtItem.vue?vue&type=template&id=288a293e&lang=pug&"
import script from "./oxtItem.vue?vue&type=script&lang=js&"
export * from "./oxtItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports